export const DemolitionServicesRoomDetails = [
  {
    id: 'flooring_demolition',
    label: 'Flooring Demolition',
    options: ['Yes']
  },
  {
    id: 'wall_demolition',
    label: 'Wall Demolition',
    options: ['Yes']
  },
  {
    id: 'sanitary_plumbing_fittings',
    label: 'Removal of Sanitary / Plumbing fittings',
    options: ['Yes']
  },
  {
    id: 'skirting_demolition',
    label: 'Skirting Demolition',
    options: ['Yes']
  },
  {
    id: 'wall_tile_demolition',
    label: 'Wall Tile Demolition',
    options: ['Yes']
  },
  {
    id: 'cabinet_removal',
    label: 'Removal of Cabinets',
    options: ['Yes']
  },
  {
    id: 'floor_platform_demolition',
    label: 'Floor Platform Demolition',
    options: ['Yes']
  },
  {
    id: 'countertop_removal',
    label: 'Countertop removal',
    options: ['Yes']
  },
  {
    id: 'removal_wallpaper',
    label: 'Removal of Wallpaper',
    options: ['Yes']
  },
  {
    id: 'wooden_flooring_removal',
    label: 'Wooden Flooring Removal',
    options: ['Yes']
  },
  {
    id: 'rcc_removal',
    label: 'RCC Removal',
    options: ['Yes']
  },
  {
    id: 'false_ceiling_cornice',
    label: 'Removal of False Ceiling / Cornice',
    options: ['Yes']
  },
];

export const DemolitionServicesQuantity = [
  {
    id: 're_plastering',
    label: 'Re-plastering by (Civil)',
    options: ['HomeLane', 'Customer', 'Not Applicable']
  },
  {
    id: 'tile_supply',
    label: 'Tile Supply',
    options: ['HomeLane', 'Customer', 'Not Applicable']
  },
  {
    id: 'tile_installation',
    label: 'Tile Installation (Civil)',
    options: ['HomeLane', 'Customer', 'Not Applicable']
  },
  {
    id: 'sanitary_fixture_supply',
    label: 'Sanitary Fixture Supply',
    options: ['HomeLane', 'Customer', 'Not Applicable']
  },
  {
    id: 'sanitary_fixture_installation',
    label: 'Sanitary Fixture Installation (Plumbing)',
    options: ['HomeLane', 'Customer', 'Not Applicable']
  },
  {
    id: 'debris_removal ',
    label: 'Debris Removal ',
    options: ['HomeLane', 'Customer', 'Not Applicable']
  },
  {
    id: 'plumbing_fitting_supply',
    label: 'Plumbing fitting Supply',
    options: ['HomeLane', 'Customer', 'Not Applicable']
  },
  {
    id: 'plumbing_fitting_installation',
    label: 'Plumbing fitting Installation (Plumbing)',
    options: ['HomeLane', 'Customer', 'Not Applicable']
  },
]